export default __webpack_public_path__ + "media/images/react_icons/lightbulb-03e74078b08565c6fd15dc7329b56563.svg";